'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ChatEvent = function ChatEvent(_ref) {
    var message = _ref.message,
        sender_timestamp = _ref.sender_timestamp;

    return _react2.default.createElement(
        'div',
        { className: 'row msg_container text-center' },
        _react2.default.createElement(
            'div',
            { className: 'col-md-12 col-xs-12 no-padding' },
            _react2.default.createElement(
                'p',
                null,
                _react2.default.createElement(
                    'span',
                    { className: 'label label-default' },
                    message
                ),
                ' ' + (0, _moment2.default)().to(sender_timestamp)
            )
        )
    );
};

exports.default = ChatEvent;


// WEBPACK FOOTER //
// ../chat/lib/components/chatbox/chatevent.js